export type StrictOmit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

export const strictOmit = <T extends {}, K extends keyof T>(k: K, { [k]: _, ...rest }: T): StrictOmit<T, K> => rest
